"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.QUERY_ID_FOR_OFFER_DETAILS = exports.OPTIONS_CONTROLS_TYPES = exports.OFFER_DETAILS_MODAL_ID = exports.DESCRIPTION_ID = exports.DATE_FORMAT = void 0;
var QUERY_ID_FOR_OFFER_DETAILS = exports.QUERY_ID_FOR_OFFER_DETAILS = 'offer-details';
var DATE_FORMAT = exports.DATE_FORMAT = 'DD.MM.YYYY';
var DESCRIPTION_ID = exports.DESCRIPTION_ID = 'Description';
var OFFER_DETAILS_MODAL_ID = exports.OFFER_DETAILS_MODAL_ID = 'OfferDetailsModal';
var OPTIONS_CONTROLS_TYPES = exports.OPTIONS_CONTROLS_TYPES = {
  CHECKBOX: 'checkbox',
  TEXT: 'text',
  DATE: 'date',
  EMAIL: 'email',
  PHONE: 'phone',
  TEXTAREA: 'textarea'
};